import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {getRoles, GetMenuHeader, GetMenuHeaderByGroup, validateUrl} from '../../functions';
import axios from 'axios';
import cookie from 'react-cookies';
import {API_URL} from '../../constants';

import $ from 'jquery';

export default class Administradores extends Component {
    
    constructor(props) {
        super(props); 
        this.state = {
            menuGeneral:  [],
            menus:        [],
            agrupador:    "Administradores",
            security:     cookie.load('user'),
            roles:        []
        }
    }

    componentDidMount(){        
        if($('#containerPanel').is("*")){
            $('#containerPanel').hide();
        }

        let newState  = this.props.location.state;
        let agrupador = this.state.agrupador;
        // console.log("load menu", newState);  

        validateUrl(this.props.menuGeneral, "", agrupador);     
        // var menus = GetMenuHeaderByGroup(this.props.menu, agrupador);

        console.log("load menu", this.props.menu);  

        let menuByGroup = this.props.menu.find((item) => item.sAgrupador === agrupador).sMenu;

        this.setState({
            menuGeneral: this.props.menuGeneral,
            menus:       menuByGroup
        });         
    }

    render() {
        let pathname = this.props.history.location.pathname;
        let data = this.state.menus.length > 0 ? this.state.menus.filter((item) => item.sUrl !== pathname) : [];

        return (
            <div>
                <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt />
                        <a  href="/">
                            / Panel de Configuración General
                        </a >
                        <span> / Administradores</span>
                    </div>
                </div>
                <div className="divTitulo_Panel">
                    Panel de Administradores
                </div>
                <div className="divConfiguracion_Modulos">
                    {
                        data.length > 0 ?
                        data.map((opcion, key) => {
                            if(pathname !== opcion.sUrl){
                              return <div key={key} className="divModulos_General">
                                  <Link className="glosario_link" to={{
                                      pathname:opcion.sUrl,
                                      state: { agrupador:this.state.agrupador, menuGeneral: this.state.menuGeneral}
                                  }}>
                                      <img src="../static/images/icoConfiguracion.png" alt="" />
                                      <span>{opcion.sOpcNombre}</span>
                                  </Link>
                              </div>
                            }
                          })
                        : 
                        <div>
                            <div className='text-danger'>
                                No cuenta con permisos para visualizar esta opción
                            </div>
                            <Link to="/" className='btn btn-primary mt-2'>
                                <i className='fa fa-home mr-2'></i>Volver al inicio
                            </Link>
                        </div>
                    }
                    <div className="clear" />
                </div>
            </div>
        )
    }
}